module.exports = __webpack_public_path__ + "static/media/9DESA4.aea97403.jpg";